module.exports = __webpack_public_path__ + "img/fiturJasa.1fb78045.png";